import { Subscript } from './subscript.js'

export * from './subscript.js'

export default Subscript
